import React from 'react';
import { makeStyles, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { StatusWarning } from '@backstage/core-components';

const useStyles = makeStyles({
  denseListIcon: {
    marginRight: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  }
});
const EscalationUsersEmptyState = () => {
  const classes = useStyles();
  return /* @__PURE__ */ React.createElement(ListItem, null, /* @__PURE__ */ React.createElement(ListItemIcon, null, /* @__PURE__ */ React.createElement("div", { className: classes.denseListIcon }, /* @__PURE__ */ React.createElement(StatusWarning, null))), /* @__PURE__ */ React.createElement(ListItemText, { primary: "No one is on-call. Update the escalation policy." }));
};

export { EscalationUsersEmptyState };
//# sourceMappingURL=EscalationUsersEmptyState.esm.js.map
